var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconSales({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.493 10.636c-.57 0-1.035.453-1.035 1.011 0 .558.464 1.012 1.035 1.012s1.035-.454 1.035-1.012-.464-1.011-1.035-1.011M6.332 5.595c-.57 0-1.035.454-1.035 1.012 0 .557.464 1.01 1.035 1.01s1.036-.453 1.036-1.01c0-.558-.465-1.012-1.036-1.012"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.493 13.748c-1.186 0-2.151-.942-2.151-2.101 0-1.158.965-2.101 2.151-2.101s2.151.943 2.151 2.1c0 1.16-.965 2.102-2.151 2.102zm-5.814-.682a.564.564 0 01-.79 0 .536.536 0 010-.771l7.27-7.1a.568.568 0 01.789 0 .536.536 0 010 .77l-7.27 7.1zm.653-8.56c1.186 0 2.152.942 2.152 2.1 0 1.159-.966 2.102-2.152 2.102-1.186 0-2.151-.943-2.151-2.101 0-1.16.965-2.102 2.151-2.102zM8.92.417C4 .418 0 4.326 0 9.13c0 4.803 4.001 8.711 8.919 8.711 4.917 0 8.918-3.908 8.918-8.71 0-4.805-4-8.713-8.918-8.713z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSales);
export default __webpack_public_path__ + "static/media/icon_sales.e8ec5132490fd35da9fb687141b11262.svg";
export { ForwardRef as ReactComponent };